// extracted by mini-css-extract-plugin
export default {"AppleLoginButton":"AppleLoginButton-module-af727f1189e34e8c223e"};